<template>
    <Spinner v-if="isLoading" />
    <div class="grid">


        <div class="card col-12 mainTitle">
            <h3 class="stationsHeader">{{ translated('novaposeta').toUpperCase() }}</h3> 
            <Button
                @click="helpVisible=!helpVisible"
                icon="pi pi-question"
                :label="ponocString"
                class="helpButton p-button-rounded">
            </Button>                   
        </div>   
        
        <div class="card col-12 helpSection" v-if="helpVisible">
            <h1>Unos nove posete</h1>
            <div class="sekcijaOpis">
                Da biste uneli NOVU POSETU, prvo je potrebno izabrati ime osobe za koju su analize potrebne. Ako se osoba za koju su analize potrebne ne nalazi na spisku, možete je dodati biranjem opcije "Dodajte osobu za koju se radi analiza". Nakon što odaberete osobu, potrebno je dodati potrebne analize. Analize su organizovane po grupama i podgrupama, ali ako niste sigurni u koju grupu spada tražena analiza, koristite opciju "Brza pretraga" da unesete ime analize. Pronađenu analizu selektujete klikom na ikonicu za selektovanje sa leve strane, čime se analiza dodaje na vaš spisak. U trenutku dodavanja analize, na vrhu stranice se prikazuje ukupan iznos svih odabranih analiza, dok se u korpi povećava broj analiza.
            </div>

            <div class="sekcijaOpis">
                Klikom na <b>korpu</b> otvara se prozor koji prikazuje sve trenutno izabrane analize, uz mogućnost brisanja pojedinačnih analiza pored svake od njih.
            </div>    
            
            <div class="sekcijaOpis">
                Kada dodate sve željene analize u korpu, kliknite na dugme "Sačuvajte" kako biste sačuvali izbor. Program vas zatim vodi na sledeću stranicu gde možete videti sve odabrane analize sa cenama i QR kodom koji treba da pokažete kada dođete u laboratoriju.
            </div>            
  
        </div>

    

    <div class="grid stickyRow">
        <div class="col-12 sm:col-10" @click="showSelection">
            <div class="iznosanalizaplaceholder headerbuttonslarge">
                <label class="iznosanalizatitle showDesktopOnly">{{ translated('totalAmount').toUpperCase() }}</label>
                <label class="iznosanaliza">{{ this.getPriceSum()  }}</label>
                <div class="shoppingCartPlaceholder">
                    <div class="shoppingCartBadge">{{ this.selectedData.length  }}</div>
                    <i class="pi pi-shopping-cart checkoutCart"></i>                        
                </div>
                
            </div>
        </div>
        <div class="col-12 sm:col-2"  @click="saveAnalysis">
            <div class="brojanalizaplaceholder headerbuttonslarge">                        
                <i class="pi pi-save analizaSaveIcon"></i> 
                <label class="brojanalizatitle">{{ translated('save') }} </label>
            </div> 
        </div>                
    </div>

    <div class="card grid selectedAnalize">
        <div class="col-12">
            <div v-if="!displayModalUser" class="p-fluid grid elementGroup childUsersCombo">
                <div class="col-12 usercombolabel">
                    <label>{{ translated('zahtevza') }} </label>
                </div>                
                <div class="col-12 childUsers">
                    <!-- <Dropdown @change="personChange" panelStyle="style='Class=TestTest'" panelClass="childPersons" v-model="selectedPerson" :options="PersonOptions" optionLabel = "label" optionValue = "value" placeholder="Izaberite osobu" id="person"> -->
                    <Dropdown @change="personChange" v-model="selectedPerson" :options="PersonOptions" optionLabel = "label" optionValue = "value" :placeholder=this.selectedPersonPlaceholder id="person">
                        <template #option="slotProps">
                            <div class="country-item">                        
                                <div class="ComboLastRow">{{slotProps.option.label}}</div>
                            </div>
                        </template>
                    </Dropdown>
                </div>
            </div>
            <div v-else class="p-fluid grid elementGroup">
                <div class="col-12">
                    <label>{{ translated('requesteBy') }} </label>
                </div>                   
                <div class="col-12">
                    <Dropdown v-model="selectedPerson" :options="PersonOptions" optionLabel = "label" optionValue = "value" placeholder="Izaberite osobu" id="person"/>
                </div>
            </div>
        </div>
    </div>

    <AnalysisSelector class="tableAnalysis" ref="myNewAnalysis" :MasterGroups=MasterGroups :GridData=AllAnalysis :BlodId=BlodId :BlodReletedItems=BlodReletedItems @selectionChanged="AnalysisChanged"></AnalysisSelector>
    <Dialog class="dialogPrevievOrder" v-model:visible="openSelectionModal" modal header="Izabrane analize" :style="{ width: '30vw' }" :breakpoints="{ '960px': '50vw', '641px': '100vw' }">
        <div class="col-12">
            <div class="placegoldersumborder">
                <div v-for="x in selectedData" :key="x" class="grid">
                <div class="col-8">{{ x.name }}</div> 
                <div class="col-4 modalPrice">
                    <div class="rowSum">
                        {{this.formatAsCurrency(x.price)}}
                    </div>
                    <div class="rowDelete">
                        <Button icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="removeItemWithIdFromModal(x.aid)"></Button>
                    </div>                    
                </div>
            </div>
            </div>
            <div class="grid">
                <div class="col-12">
                    <div class="modalPriceSum">
                        {{ this.getPriceSum() }}
                    </div>                    
                </div>                
            </div>

        </div>

    </Dialog>
    <Dialog class="modal-profile" :header="translated('insertNewUser')" v-model:visible="displayModalUser" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}">
      <div class="grid">  
        <Person ref="personModal" @saved="childSaved"></Person>
      </div> 
      <template #footer>
        <div class="modal-buttons">
          <Button :label="translated('insertUser')" icon="pi pi-check" @click="saveChild()" class="submitbtn" />
          <Button :label="translated('goBack')" icon="pi pi-times" @click="displayModalUser=false" autofocus class="submitbtn" />
        </div>
      </template>
    </Dialog>


    <form id="paymentForm" method="post" action="https://entegrasyon.asseco-see.com.tr/fim/est3Dgate">
        <input type="hidden" name="clientid" value="250300000" />
        <input type="hidden" name="amount" value="250.50" />
        <input type="hidden" name="oid" value="" />
        <input type="hidden" name="okUrl" value="http://localhost:8080/analysisreview/c391a865-2596-4883-98b1-2e17ae7cf59b" />
        <input type="hidden" name="failUrl" value="http://localhost:8080/" />
        <input type="hidden" name="islemtipi" value="Auth" />
        <input type="hidden" name="taksit" value="" />
        <input type="hidden" name="rnd" value="{{ new Date().getTime() }}" />
        <input type="hidden" name="hash" value="<%=hash%>" />
        <input type="hidden" name="currency" value="<%= currency %>" />
        <input type="hidden" name="storetype" value="3d_pay_hosting" />
        <input type="hidden" name="refreshtime" value="10" />
    </form>    


    </div>


</template>

<script>
import AnalysisSelector from '@/components/AnalysisSelector.vue';
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";
import Dropdown from 'primevue/dropdown';
import { useVuelidate } from "@vuelidate/core";
import { required, email, numeric, minLength, maxLength, } from "@vuelidate/validators";
import Spinner from "@/components/Spinner.vue"
import Person from '@/components/Person.vue';


export default {
    components: { AnalysisSelector, Dropdown, Spinner, Person},
    props: ['id','source', 'linked', 'homevisitid','autosave'],
    setup: () => ({ v$: useVuelidate() }),
    data() {
      return {
        translated: computed(() => store.getters.getTranslate),
        MasterGroups: [],
        AllAnalysis: [],
        BlodId: null,
        BlodReletedItems: [],
        isLoading: false,
        tempId: null,
        selectedData: [],
        openSelectionModal: false,
        selectedPerson: null,
        PersonOptions: [],
        submitted: false,
        displayModalUser: false,
        submittedModal: false,
        parentpersonid:'',
        dateinserted:'',
        displayModalText:false,
        initFrom: null,
        initTill: null,
        selectedPersonPlaceholder: 'Izaberite osobu',
        homeVisitSaved: false,
        parentName: '',
        genders: [{ id: 0, name: 'Muško' }, { id: 1, name: 'Žensko' }],
        gender: '',
        ownerPersonId: computed(() => store.getters.getUserId),
        helpVisible: false
      }
      
    },
    computed: {
        ponocString() {
            return this.translated('translatedHelp');
        }
    },
    validations() {              
        let myvalidations = {
          selectedPerson:{ required },
        };
        let myModalValidations = {
          name: {  required },
          surname: { required },
          personalregistrationnumber: { minLength: minLength(13), maxLength: maxLength(13), required },
          email:{ required, email },
          address:{ required },
          zip: { minLength: minLength(5), maxLength: maxLength(5), required },
          city: { required },            
          mobilephone: { required },
          selectedCountry: {required, minLength: minLength(10) },
          parentName: { required },
          gender: { required }
        };
        if(this.displayModalUser)
        {
            return myModalValidations;
        };
        return myvalidations;
    },

    async mounted() {
        this.isLoading = true;
        debugger;
        
        this.selectedPerson = this.ownerPersonId;
        const http = createHttp(true);
        
        // console.log(this.id +"////////////////////////////////////////////////////////////////////////////////////////////"); 

        const resultData = await http.get(process.env.VUE_APP_API_FOLDER + "/getPriceGroupSettings");
        if(resultData.status==200){
            // console.log('PREJEL PODATKE OD SERVERJA ZA PRICE LIST!!!!');
            // console.log(resultData.data);

            this.AllAnalysis = resultData.data.items;
            this.MasterGroups = resultData.data.masterGroup;
            this.BlodId = resultData.data.blodId;
            this.BlodReletedItems = resultData.data.blodReletedItems;            
        }

        debugger;

        if(!this.isEmptyGuid(this.id))
            localStorage.removeItem('selectedAnalize');

        let tmpSelectedAnalize = localStorage.getItem('selectedAnalize');
        if(tmpSelectedAnalize){
            this.selectedData = JSON.parse(tmpSelectedAnalize);
            this.$refs.myNewAnalysis.addAnalysisItems(this.selectedData);
        }

        debugger;
        // console.log('ZOVEM API PERSONWITHCHILDREN************************************************************************************')
        const result1 = await http.get(process.env.VUE_APP_API_FOLDER + "/getPersonWithChildren?all=true");
        // console.log(result1)

        if(result1.status == 200){
            this.PersonOptions=[];
            for (let x in result1.data) {
              this.PersonOptions.push(
              {label:result1.data[x].name + " " + result1.data[x].surname, value: result1.data[x].id}
            )};
            this.PersonOptions.push({label: this.translated('addPerson'), value: "other", class:"nesto-novo"});
        }

        debugger;
        if(this.isValidGuid(this.id)){
            const resultAnaliza = await http.get(process.env.VUE_APP_API_FOLDER + "/GetAnalysisRequest?id=" + this.id);
            this.selectedPerson = resultAnaliza.data.analysisPersonId;

            for (let x in resultAnaliza.data.analysisItems) {
                const myCurrElement = resultAnaliza.data.analysisItems[x];
                const tmpEl = this.AllAnalysis.find(y => y.aid == myCurrElement.partnerAnalysisId);
                if(tmpEl != undefined) {
                    this.selectedData.push(tmpEl);                      
                }
            }
            this.$refs.myNewAnalysis.addAnalysisItems(this.selectedData);               
        }


        if (this.$route.params.autosave) {
            await this.saveAnalysis();
        }

        this.isLoading = false;
    },

    methods: {
        async childSaved(savedperson) {
            debugger;
            this.displayModalUser=false;     
            // Sedaj bi moral to Insertat v Combo in ga nastaviti na ta na novo insertan zapis            
            this.PersonOptions.unshift({label: savedperson.name + " " + savedperson.surname, value: savedperson.id});
            this.selectedPerson = savedperson.id;
            debugger;
        },
        saveChild() {
            this.$refs.personModal.Save();
        },

        async saveAnalysis(){
            debugger;
            this.isLoading = true;

            let tmpId = this.id;
            if(!this.isValidGuid(tmpId) || this.source == 'duplicatedAnalysis') {
                tmpId = '00000000-0000-0000-0000-000000000000';
            }
            let postAnalysis = {
                Id: tmpId,
                Linked: this.linked == "true" ? true : false,
                RequestDate: new Date(),
                TotalPrice: this.getPriceSumNumber(),
                OwnerPersonId: this.ownerPersonId,
                AnalysisPersonId: this.selectedPerson,
                Paid: false,
                PaidPartnerNotified: false,
                Status: 0,
                LastStatusChange: new Date(),
                AnalysisItems: []
            };

            for (let x in this.selectedData) {
                postAnalysis.AnalysisItems.push({
                    PartnerAnalysisId: this.selectedData[x].aid,
                    Name: this.selectedData[x].name,
                    Price: this.selectedData[x].price
                })
            }

            const http = createHttp(true); 
            try {
                await http.post(process.env.VUE_APP_API_FOLDER + "/SaveAnalysisRequest", postAnalysis)
                    .then((response) => { 
                        debugger;
                        localStorage.removeItem("selectedAnalize");
                        // Tu je potrebno pogledati kaj je v source. 
                        if(this.source == "review" || this.source == "dashboard" || this.source == "duplicatedAnalysis") {
                            this.$router.push({ name: 'AnalysisReview', params: { id: response.data.id } });                        
                        }                            
                        else if(this.source == "homevisit") {   
                            if(this.isValidGuid(this.homevisitid) && !this.isEmptyGuid(this.homevisitid)) {
                                this.$router.push({ name: 'HomeVisitReview', params: { id: this.homevisitid } });   
                            } else {
                                this.$router.push({ name: 'NewHomeVisit', params: { aid: response.data.id } });                        
                            }                    
                            
                        }
                            
                    })
                    .catch((error) => {
                        debugger;
                        const myErr = {...error};

                        // console.log('ERROR');
                        // console.log(myErr) 
                        this.Errors = myErr.response.data.Errors;
                })
            } 
            catch (error) {
                debugger;
                // console.log(error);
            }

            this.isLoading = false;

        },
        AnalysisChanged(data) {
            this.selectedData = data;
            // console.log('AnalysisChanged');
            // console.log(data);

            this.saveChecked();
        },
        removeItemWithId(){
            this.selectedData = this.selectedData.filter(item => item.aid != this.tempId);
            this.$refs.myNewAnalysis.RemoveItem(this.tempId);            
        },
        removeItemWithIdFromModal(id){
            if(id==this.BlodId) return;


            this.selectedData = this.selectedData.filter(item => item.aid != id);
            this.$refs.myNewAnalysis.RemoveItem(id);
            if(this.selectedData.length == 0){
                this.openSelectionModal = false;
            }
        },

        formatCurrency(value) {
            let formatted = value.toLocaleString('rs-RS', {style: 'currency', currency: 'RSD'});
            formatted = formatted.replace(/(^\D*)([\d,.]*)(\D*$)/, "$2 $1").trim();
            return formatted;
        },

        getPriceSum() {
            const total = this.getPriceSumNumber();
            const formattedTotal = this.formatCurrency(total);
            return formattedTotal;
        },
        getPriceSumNumber() {
            const total = this.selectedData.reduce((accumulator, currentItem) => {
                return accumulator + currentItem.price;
            }, 0);

            return total;
        },        
        showSelection() {
            if(this.selectedData.length > 0) {
                this.openSelectionModal = true;
            }
        },
        formatAsCurrency(item){
            const formatteditem = this.formatCurrency(item);
            return formatteditem;
        },
        payAnalize() {
            
        },
        saveChecked() {
            debugger;
            localStorage.setItem('selectedAnalize', JSON.stringify(this.selectedData));
        },
        personChange(e) {
            debugger;
            // console.log('Selected value guid: ' + e.value);
            if (e.value === 'other') {          
                this.displayModalUser=true;          
                this.$nextTick(() => {
                    this.$refs.personModal.Clear();
                    this.$refs.personModal.UnlockAll();
                }); 
            }
        },
        isValidGuid(guid) {
            const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
            const emptyGuid = '00000000-0000-0000-0000-000000000000';
            return guidRegex.test(guid) && guid !== emptyGuid;
        },
        isEmptyGuid(guid) {
            return '00000000-0000-0000-0000-000000000000' == guid;
        }
    },
}

     
</script>

<style scoped>
label.brojanaliza, label.iznosanaliza {
    margin-left: 10px;
}
label.brojanaliza, label.iznosanaliza, label.iznosanalizatitle  {
    font-weight: bold;
    font-size: 1.5em;
}

.card.grid.selectedAnalize {margin: 10px 0px 10px 0px !important;}

.brojanalizaplaceholder, .iznosanalizaplaceholder, .brojanalizatitle, .brojanaliza, .iznosanalizatitle, .iznosanaliza {cursor: pointer;}
.brojanalizaplaceholder:hover, .iznosanalizaplaceholder:hover { opacity: 0.8;}

.modalPriceSum {
    float: right;
    margin-right: 55px;
    font-size: 1.4rem;
    font-weight: bold;
    padding-top: 10px;
}

.rowDelete {
    width: 35px;
    position: relative;
    float: left;
}

.rowSum {
    position: relative;
    float: left;
    width: calc(100% - 35px);
    height: 35px;
    text-align: right;
    padding-right: 20px;
}

button.p-button.p-component.p-button-icon-only.p-button-rounded.p-button-danger {
    background: #e6cece;
    border-color: transparent;
}

button.p-button.p-component.p-button-icon-only.p-button-rounded.p-button-danger:hover {background: red;}
.placegoldersumborder {border-bottom: 1px solid #6c757d;}
.non-responsive-table.tableAnalysis span.p-column-title {display:none !important;}
.non-responsive-table.tableAnalysis span.p-column-title {display:none !important;}
.iznosanalizaplaceholder, .brojanalizaplaceholder {width: 100%;}

.rowDelete > button {
    width: 20px !important;
    height: 20px !important;
}


i.pi.pi-shopping-cart.checkoutCart {
    position: absolute;
    font-size: 45px;
    color: #333333;
    top: -3px;
}

.shoppingCartBadge {
    position: absolute;
    float: left;
    border-radius: 10px;
    width: 20px;
    height: 20px;
    font-size: 13px;
    text-align: center;
    left: 14px;
    top: 10px;
    font-weight: 800;
    color: #c40e19;
}

.shoppingCartPlaceholder {
    position: relative;
    float: right;
    width: 40px;
    height: 40px;
    margin-right: 10px;
}

@media screen and (max-width: 720px)
{
    /* label.brojanalizatitle, .showDesktopOnly {display: none;} */
    
}

.headerbuttonslarge {
    height: 70px;
}

.brojanalizaplaceholder.headerbuttonslarge {
    display: grid;
    align-items: center;
    justify-items: center;
}

i.pi.pi-save.analizaSaveIcon {
    font-size: 25px;
}

i.analizaSaveIcon {
    font-size:x-large;
}

.brojanalizaplaceholder.headerbuttonslarge {
    background: #3B82F6;
    color: white;
    font-weight: 300;
}

.usercombolabel {
    padding-bottom:0px;
    padding-top:20px;
    font-weight: 500
}


.card.grid.selectedAnalize {width: 100%;}
.non-responsive-table.tableAnalysis {width: 100%;}


.stickyRow {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  float: left;
  background: #6c757d;
  margin-left: 0px;
}


</style>